import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class EErgoRequestFormConfigService {
  private readonly eErgoRequestFormConfigBaseApiUrl: string;  

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.eErgoRequestFormConfigBaseApiUrl = `${baseUrl}api/eergo/requestform/config`;
  }

  public getEErgoRequestFormConfigOptions() {
    let eErgoRequestFormConfigOptionsApiUrl = `${this.eErgoRequestFormConfigBaseApiUrl}/options`;

    return this.dataService.get<any>(eErgoRequestFormConfigOptionsApiUrl);
  }

  public getEErgoRequestFormConfig(configId: string) {
    let eErgoRequestFormOptionsApiUrl = `${this.eErgoRequestFormConfigBaseApiUrl}/${configId}`;

    return this.dataService.get<any>(eErgoRequestFormOptionsApiUrl);
  }
}
